import { Component, EventEmitter, Input, Output, OnInit, ViewChild, OnChanges } from '@angular/core';

import { TranslateService } from 'ng2-translate';

@Component({
    selector: 'app-info-dash',
    templateUrl: './infoDash.component.html',
    styleUrls: ['./infoDash.component.scss'],
    providers: []
})


export class InfoDashComponent implements OnInit {

    @Input() mensaje: string;

    msgs: any[] = [];

    constructor(
        private translate: TranslateService,
    ){

    }

    ngOnInit(): void {
        
    }

    show(){
        this.msgs = [];
        const tr_tx = this.translate.instant(this.mensaje);
        this.msgs.push({severity: 'info', summary: 'Info', detail: tr_tx});
    }

    hide(){
        this.msgs = [];
    }

    pulsado(evento){
        this.show();
    }



}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/graficas/infoDash/infoDash.component.ts